import React, { Suspense } from "react";
import LoadingOverlay from "../components/LoadingOverlay";

export function withSuspense(
  Component,
  FallbackComponent = <LoadingOverlay />
) {
  return props => (
    <Suspense fallback={FallbackComponent}>
      <Component {...props} />
    </Suspense>
  );
}
